import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from 'react-bootstrap';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import { handleChangeDataTransferPage } from '../../../../redux/actions/pages/transfer';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleChangeProfileData } from "../../../../redux/actions/pages/user/user";
import axios from "axios";
import * as qs from "querystring";
import { BASE_SITE, TRANSFER_WALLET, PAYMENT_CHARGE_WALLET } from '../../../../apis'; 
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import Swal from 'sweetalert2';

const Transfer = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.user);
    const { shopId, branchId, shopTitle, branchTitle, services, serviceSelected, amount, disableBtn, btnClass } = useSelector(state => state.transfer);
    const orgBuy = serviceSelected !== null ? services.filter(sService => sService.service === serviceSelected)[0].orgBuy : false;
    const credit = orgBuy ? (profile.user_credit + profile.user_org_credit) : profile.user_credit;
    


    const handleBackBtn = () => {
        navigate(-1);
    };


    useEffect(() => {
        if(shopId === 0)
            navigate('../transfer/search');
        // eslint-disable-next-line
    }, [Transfer]);

    useEffect(() => {
        if(parseInt(removeNonNumeric(amount)) > 0) {
            dispatch(handleChangeDataTransferPage('disableBtn', false));
            dispatch(handleChangeDataTransferPage('btnClass', ''));
        }
        else {
            dispatch(handleChangeDataTransferPage('disableBtn', true));
            dispatch(handleChangeDataTransferPage('btnClass', 'disable-btn'));
        }
        // eslint-disable-next-line
    }, [amount]);


    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }
    const handelChangeInputs = (event) => {
        const {name, value} = event.target;

        dispatch(handleChangeDataTransferPage(name, addCommas(removeNonNumeric(changeNumberPersianAndArabic(value))) ));
    };

    const handlePayClick = () => {
        if( parseInt(removeNonNumeric(amount)) <= credit )
            callApiTransfer();
        else {
            let transferAmount = parseInt(removeNonNumeric(amount));
            let transferBranch = (parseInt(branchId) + 227) * 341;
            let transferService = (parseInt(serviceSelected) + 312) * 142;
            let chargeUrl = PAYMENT_CHARGE_WALLET + `?amount=${parseInt(removeNonNumeric(amount)) - credit}&token=${token}&transferBranch=${transferBranch}&transferAmount=${transferAmount}&transferService=${transferService}`;
            window.open(chargeUrl, "_self");
        }
    };

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'primary-border primary-txt-color font-weight-300 radius-12 w-100 py-2 px-5',
        },
        buttonsStyling: false
    });

    const callApiTransfer = () => {
        dispatch(handleSetBackdropLoading(true));
        dispatch(handleChangeDataTransferPage('disableBtn', true));
        dispatch(handleChangeDataTransferPage('btnClass', 'disable-btn'));

        axios({
            method: 'post',
            url: BASE_SITE + TRANSFER_WALLET,
            data: qs.stringify({
                amount: removeNonNumeric(amount),
                branch: branchId,
                service: serviceSelected, 
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    dispatch(handleChangeDataTransferPage('disableBtn', false));
                    dispatch(handleChangeDataTransferPage('btnClass', ''));
                    break;
                case 'ok':
                    dispatch(handleChangeDataTransferPage('amount', '0'));
                    dispatch(handleChangeDataTransferPage('disableBtn', true));
                    dispatch(handleChangeDataTransferPage('btnClass', 'disable-btn'));

                    let newProfile = {...profile, 
                        user_credit: response.data.user_credit, 
                        user_org_credit: response.data.user_org_credit, 
                    };
                    dispatch(handleChangeProfileData(newProfile));

                    btnOkSingle.fire({
                        title: "تایید",
                        text: `مبلغ ${amount} ریال با موفقیت به حساب ${shopTitle} ${branchTitle} منتقل شد`,
                        imageUrl: SitagLogo,
                        imageHeight: 80,
                        imageAlt: 'سیتگ',
                        confirmButtonText: "باشه",
                    });
                    navigate('../');
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));  
                    dispatch(handleChangeDataTransferPage('disableBtn', false));
                    dispatch(handleChangeDataTransferPage('btnClass', ''));
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));  
            dispatch(handleChangeDataTransferPage('disableBtn', false));
            dispatch(handleChangeDataTransferPage('btnClass', ''));
        });
    };


    const handleRadioChange = (serviceId) => {
        dispatch(handleChangeDataTransferPage('serviceSelected', serviceId));
    };


    return (

        <div id="login-page">
            <Row className="pt-5">
                <Col xs={1} className="d-flex align-items-center"><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10} className="text-center">
                    <div className="header_h3">
                        شما در حال انتقال وجه به <strong>{shopTitle} {branchTitle}</strong> هستید
                    </div>
                </Col>
            </Row>

            <Row className="mt-5">
                <Col xs={12} className="text-center header_h4 font-weight-300">مبلغ مورد نظر جهت انتقال را وارد کنید</Col>
                <Col xs={12} className="text-center header_h5 font-weight-300 dark-blue-txt-color">
                    <span>موجودی کیف پول:  </span>
                    {orgBuy ? (profile.user_credit + profile.user_org_credit).toLocaleString() : profile.user_credit.toLocaleString()} ریال
                </Col>
                <Col xs={12} className="mt-1">
                    <div className="input-wrapper" >
                        <label className="label-wrapper" htmlFor="first" style={{right: '25px'}}>مبلغ به ریال</label>
                        <input type="text" name="amount" value={amount} onChange={handelChangeInputs} className="custom-input w-100 px-3 custom-vertical-padding" />
                    </div>
                </Col>

                <Col xs={12} className="mt-4">
                    <Button onClick={handlePayClick} className={`w-100 py-3 login-form-button ${btnClass}`} disabled={disableBtn}>
                        { 
                            parseInt(removeNonNumeric(amount)) > credit ?
                            'افزایش اعتبار کیف پول'
                            :
                            'انتقال وجه'
                        }
                    </Button>
                </Col>

                { services.length > 1 ?
                    <>
                        <Col xs={12} className="mt-3">نوع محصول  یا خدمات را انتخاب کنید</Col>
                        {
                            services.map((service, key) => {
                                return (
                                    <Col xs={12} className="mt-3" role="button" key={key}>
                                        <div className="col-service d-flex align-items-center">
                                            <label className="w-100 d-flex" role="button">
                                                <input
                                                    type="radio"
                                                    name="service"
                                                    value={service.service}
                                                    checked={serviceSelected === service.service ? true : false}
                                                    onChange={(e) => handleRadioChange(e.target.value)}
                                                    className='mr-2' />
                                                {service.title}
                                            </label>
                                        </div>
                                    </Col>
                                );
                            })
                        }
                    </>
                    :''
                }
            </Row>

        

        </div>

    );
}

export default Transfer;